export function isAuthenticatedApi(
  url: string,
  roots: readonly string[],
  origin: string,
): boolean {
  const target = new URL(url, origin);
  return (
    !target.username &&
    !target.password &&
    roots.some((root) => {
      const base = new URL(root, origin);
      const path = base.pathname.replace(/\/$/, '');
      return (
        target.origin === base.origin &&
        (target.pathname === path || target.pathname.startsWith(`${path}/`))
      );
    })
  );
}
